// extracted by mini-css-extract-plugin
module.exports = {"container":"PostMeta_container__3pVRT","skeleton":"PostMeta_skeleton__bm37d","author":"PostMeta_author__2-5E3"};